
if ($('.info-box--slider-wrap').length > 0) {

	$('.info-box--slider-wrap').each(function() {

		var _this = $(this);
		var curSlide = $(this).find('.info-box--slider').data('cur-slide');
		var totalSlides = $(this).find('.info-box--slider').data('total-slides');
		var slider = $(this).find('.info-box--slider');
		var prev = $(this).find('.info-box--slider-pagination .info-box--slider-pagination-previous');
		var next = $(this).find('.info-box--slider-pagination .info-box--slider-pagination-next');

		prev.on('click',function(e){

			e.preventDefault();

			var newSlide = 0;
			var slideAmount = 0;
			curSlide = parseInt(slider.attr('data-cur-slide'));

			if (curSlide > 1) {
				newSlide = curSlide - 1;
				slideAmount = '-' + (100 * ( newSlide - 1) ) + '%';
			} else {
				newSlide = totalSlides;
				slideAmount = '-' + (100 * (newSlide - 1) ) + '%';
			}

			slider.attr('data-cur-slide', newSlide);

			slider.animate({
				left: slideAmount
			}, 500, function() {
				// Animation complete.
			});

		});

		next.on('click',function(e){

			e.preventDefault();

			var newSlide = 0;
			var slideAmount = 0;
			curSlide = parseInt(slider.attr('data-cur-slide'));

			if (curSlide < totalSlides) {
				newSlide = curSlide + 1;
				slideAmount = '-' + (100 * ( newSlide - 1) ) + '%';
			} else {
				newSlide = 1;
				slideAmount = '0';
			}

			slider.attr('data-cur-slide', newSlide);

			slider.animate({
				left: slideAmount
			}, 500, function() {
				// Animation complete.
			});

		});

	});

}
